import { useState } from "react";
import authApi from "../../api/authApi";
import Button from "../../components/Button";
import Layout from "../../components/Layout";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { openLogin } from "../../store/slices/uiSlice";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSubmit = async () => {
        if (!isValidEmail) return;
        setError("");
        try {
            await authApi.resetPasswordRequest(email);
            setSent(true);
        } catch {
            setError("Không thể gửi email. Vui lòng thử lại.");
        } finally {
        }
    };

    const handleBackToLogin = (e: React.MouseEvent) => {
        e.preventDefault();
        navigate("/");
        dispatch(openLogin()); 
    }

    return (
        <Layout>
            <div className="min-h-screen flex justify-center items-center px-4">
            <div className="w-full max-w-md bg-white border border-gray-200 rounded-xl p-8 shadow-sm">
                {/* Header */}
                <div className="flex items-center gap-3 mb-7">
                    <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center">
                        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <rect x="3" y="11" width="18" height="11" rx="2" />
                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                        </svg>
                    </div>
                    <div>
                        <h1 className="text-base font-semibold text-gray-900">Quên mật khẩu</h1>
                        <p className="text-xs text-gray-500">Nhập email để nhận link đặt lại</p>
                    </div>
                </div>

                {!sent ? (
                    <>
                        <div className="mb-5">
                            <label className="block text-sm text-gray-500 mb-1.5">Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="you@example.com"
                                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-gray-400 transition"
                            />
                        </div>

                        {error && (
                            <p className="text-sm text-red-500 text-center mb-3">{error}</p>
                        )}
                        {/* <button
                            onClick={handleSubmit}
                            disabled={!isValidEmail || loading}
                            className="w-full py-2.5 text-sm font-medium rounded-lg bg-gray-900 text-white disabled:opacity-35 disabled:cursor-default transition"
                        >
                            {loading ? "Đang gửi..." : "Gửi link đặt lại mật khẩu"}
                        </button> */}
                        <Button label="Gửi link đặt lại mật khẩu" styleButton="w-full h-[45px]" onClick={handleSubmit} />
                    </>
                ) : (
                    <div className="text-center py-2">
                        <div className="w-12 h-12 rounded-full bg-green-50 border border-green-200 flex items-center justify-center mx-auto mb-4">
                            <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                                <polyline points="20 6 9 17 4 12" />
                            </svg>
                        </div>
                        <p className="font-semibold text-gray-900 mb-1">Email đã được gửi!</p>
                        <p className="text-sm text-gray-500 mb-5">
                            Kiểm tra hộp thư <span className="font-medium text-gray-800">{email}</span> để lấy link đặt lại mật khẩu.
                        </p>
                        {/* <button
                            onClick={() => { setSent(false); setEmail(""); }}
                            className="text-sm text-gray-400 underline"
                        >
                            Gửi lại email khác
                        </button> */}
                        <Button label="Gửi lại email khác" styleButton="w-full h-[45px]" onClick={() => { setSent(false); setEmail(""); }} />
                    </div>
                )}

                <div className="border-t border-gray-100 mt-6 pt-4 text-center">
                    <a href="/" className="text-sm text-gray-400 hover:text-gray-600 transition" onClick={handleBackToLogin}>
                        ← Quay lại đăng nhập
                    </a>
                </div>
            </div>
        </div>
        </Layout>
    );
}